import { Layout } from "antd";
import { Outlet } from "react-router-dom";
import ResellerSidebar from "./ResellerSidebar";

const { Content } = Layout;

export default function ResellerLayout() {
  return (
    <Layout className="reseller-shell">
      <ResellerSidebar />

      <Layout className="reseller-shell__content">
        <Content className="reseller-shell__inner">
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
}
